<header class="app-header">
  @if (isHomePage$ | async) {
    <span class="app-header__logo-link">
      <img src="/assets/img/logo.svg" class="app-header__logo" alt="Logo" />
    </span>
  } @else {
    <a class="app-header__logo-link" [routerLink]="homeUrl">
      <img src="/assets/img/logo.svg" class="app-header__logo" alt="Logo" />
    </a>
  }

  <div class="app-header__content">
    @if (!(isHomePage$ | async)) {
      <a class="app-header__home" [routerLink]="homeUrl">Home</a>
    }

    <img class="app-header__igc-logo" src="/isotipo-igc.svg" alt="IGC Pharma" />


    @if (helpBubble.hasContent()) {
      <button
        class="app-header__help-btn"
        type="button"
        aria-label="Help"
        [attr.aria-expanded]="helpBubble.isOpen()"
        (click)="helpBubble.toggle()"
      >
        ?
      </button>
    }
  </div>
</header>